import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserSettings,
  clearUserSettings,
  fetchTimeOffset,
  fetchAppSettingByID,
} from "../services/userSettings";

const initialState = {
  isLoading: false,
  error: null,
  data: [],
  //offsetValue: "",
  appSetting: [],
  // isAvatarLoading: false,
  // avatarError: null,
  // file: [],
};

const userSettings = createSlice({
  name: "userSettings",
  initialState,
  reducers: {
    fetchStarted: (state) => {
      state.isLoading = true;
    },
    fetchFulfilled: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchRejected: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchCleared: (state, action) => {
      state.data = action.payload;
      state.error = null;
    },
    fetchTimezone: (state, action) => {
      state.offsetValue = action.payload;
    },

    fetchAppSettingStarted: (state) => {
      state.isLoading = true;
    },
    fetchAppSettingFulfilled: (state, action) => {
      state.isLoading = false;
      const { id } = action.payload;
      const exists = state.appSetting.find((p) => p.id === id);
      if (!exists) {
        state.appSetting.push(action.payload);
      }
      //state.appSetting = [...state.appSetting, action.payload];
      state.error = null;
    },
    fetchAppSettingRejected: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// fetch Thunk
const fetchSettings = (id) => async (dispatch) => {
  const { fetchStarted, fetchFulfilled, fetchRejected } = userSettings.actions;
  dispatch(fetchStarted());

  try {
    const res = await fetchUserSettings(id);
    dispatch(fetchFulfilled(res));
    //console.log("UserSettings" + JSON.stringify(res));
    return res;
  } catch (err) {
    dispatch(fetchRejected(err.message));
  }
};

const clearSettings = (id) => (dispatch) => {
  const { fetchCleared } = userSettings.actions;

  const res = clearUserSettings(id);
  dispatch(fetchCleared(res));
};
const fetchTime = () => async (dispatch) => {
  const { fetchTimezone } = userSettings.actions;
  try {
    const res = await fetchTimeOffset();
    dispatch(fetchTimezone(res));
    return res;
  } catch (err) {
    console.log("Couldn't get timeoffset: " + err);
  }
};

const fetchAppSettings = (settingID) => async (dispatch) => {
  const {
    fetchAppSettingStarted,
    fetchAppSettingFulfilled,
    fetchAppSettingRejected,
  } = userSettings.actions;

  dispatch(fetchAppSettingStarted());
  try {
    //setting id 376 is for appointment duration increments
    const res = await fetchAppSettingByID(settingID);
    dispatch(fetchAppSettingFulfilled(res));
    return res;
  } catch (err) {
    dispatch(fetchAppSettingRejected(err.message));
    console.log("Couldn't get setting: " + err);
  }
};
// const fetchAvatar = () => async (dispatch) => {
//   const {
//     fetchAvatarStarted,
//     fetchAvatarFulfilled,
//     fetchAvatarRejected,
//   } = userSettings.actions;

//   console.log("fetch dispatched...");

//   dispatch(fetchAvatarStarted());

//   try {
//     const res = await fetchMyAvatar();
//     dispatch(fetchAvatarFulfilled(res));
//     return res;
//   } catch (err) {
//     dispatch(fetchAvatarRejected(err));
//   }
// };

export const action = {
  ...userSettings.actions,
  fetchSettings,
  clearSettings,
  fetchTime,
  fetchAppSettings,
  // fetchAvatar,
};

// selectors;
export const isUserSettingsLoading = (state) => state.isLoading;
export const getUserSettings = (state) => state.data;
export const getUserSettingsError = (state) => state.error;

export const getUserProfileImage = (state) => state.data && state.data.avatar;
export const getUserLogo = (state) => state.data && state.data.logo;
export const getTimeOffset = (state) => {
  const timeSetting = state.appSetting.find((setting) => setting.id === 36);
  const timeOffset = Number(timeSetting.value);
  return timeOffset;
  //state.offsetValue;
};
export const getDurationIncrement = (state) => {
  const durationSetting = state.appSetting.find(
    (setting) => setting.id === 376
  );
  const durationInc = Number(durationSetting.value);
  return durationInc;
  //state.offsetValue;
};
//export const getDurationIncrement = (state) => state.appSetting.value;
// export const isAvatarLoading = (state) => state.isAvatarLoading;
// export const getAvatar = (state) => state.file;
// export const getAvatarError = (state) => state.avatarError;

export default userSettings.reducer;
